export default __webpack_public_path__ + "static/media/granville13.e4ca2538.jpg";